import { PropsWithChildren, Suspense, lazy } from 'react';
import { useGrowthbookSubdomainFlags } from 'src/common/hooks/useGrowthbookSubdomainFlags';
import useAuthContext from 'src/context/AuthProvider/useAuthContext';
import VerificationScreen from 'src/features/auth/presentation/screens/VerificationScreen';
import LoaderOverlay from 'src/components/Loader';

const AuthLayout = lazy(() => import('src/common/layout/AuthLayout'));

export default function VerificationProvider({ children }: PropsWithChildren) {
  const { session } = useAuthContext();
  const isPhoneVerificationEnabled = useGrowthbookSubdomainFlags(
    'ENABLE_SIGNUP_PHONE_OTP',
    false
  );
  const isEmailVerificationEnabled = useGrowthbookSubdomainFlags(
    'ENABLE_SIGNUP_EMAIL_OTP',
    false
  );
  const isVerificationEnabled = useGrowthbookSubdomainFlags(
    'ENABLE_VERIFY_ID_PROVIDER',
    false
  );

  const isEmailVerified = session?.user.email_verified;
  const isPhoneVerified = session?.user.phone_verified;
  const isIdVerified = session?.user.id_verified;

  const isUserDefined = session?.user !== undefined;

  const mustVerifyPhone = isUserDefined
    ? !isPhoneVerified && isPhoneVerificationEnabled
    : false;
  const mustVerifyEmail = isUserDefined
    ? !isEmailVerified && isEmailVerificationEnabled
    : false;
  const mustVerifyId = isUserDefined
    ? !isIdVerified && isVerificationEnabled
    : false;

  const hasPendingVerification =
    mustVerifyEmail || mustVerifyPhone || mustVerifyId;

  if (hasPendingVerification) {
    return (
      <Suspense fallback={<LoaderOverlay />}>
        <AuthLayout>
          <VerificationScreen />
        </AuthLayout>
      </Suspense>
    );
  }

  return children;
}
